import React from 'react';
import PrivacyPolicyPage from './PrivacyPolicyPage';

const TickFlipPrivacyPolicy = () => {
  return (
    <PrivacyPolicyPage
      title='TickFlip Clock Privacy Policy'
      intro={[
        <>
          <b>TickFlip Clock</b> is provided by <b>Kadjo Benjamin Anoh</b> at no
          cost and is intended for use as-is. This page informs you of our
          policies regarding privacy while using the app.
        </>,
      ]}
      sections={[
        {
          title: 'No Data Collected',
          paragraphs: [
            'TickFlip Clock does not collect, store, or share any personal information or usage data. We do not use analytics, tracking, or third-party advertising services.',
          ],
        },
        {
          title: 'Third-Party Services',
          paragraphs: [
            'TickFlip Clock does not integrate with any third-party services that collect user data.',
          ],
        },
        {
          title: 'Children’s Privacy',
          paragraphs: [
            'Since TickFlip Clock does not collect any data, it does not knowingly collect information from children under 13.',
          ],
        },
      ]}
      effectiveDate='2025-09-03'
      contactEmail='benjaminanoh@gmail.com'
    />
  );
};

export default TickFlipPrivacyPolicy;
